import {
  BankAccountFormSchemaType,
  getEditBankAccountDefaultValues,
  useBankAccountFormSchema,
} from '..';
import type { BankAccountType } from '@api';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, UseFormReturn } from 'react-hook-form';

type UseEditBankAccountFormReturnType =
  UseFormReturn<BankAccountFormSchemaType>;

export const useEditBankAccountForm = (
  bankAccount: BankAccountType
): UseEditBankAccountFormReturnType => {
  const { schema } = useBankAccountFormSchema();

  return useForm({
    defaultValues: getEditBankAccountDefaultValues(bankAccount),
    resolver: zodResolver(schema),
  });
};
